export default __webpack_public_path__ + "media/zurb/img/ecommerce/jab_3-f190fbccad6ccca97ccc3dd0cf046bc6.png";